import { render, staticRenderFns } from "./merchantProduct.vue?vue&type=template&id=79f01f8e&scoped=true"
import script from "./merchantProduct.vue?vue&type=script&lang=ts"
export * from "./merchantProduct.vue?vue&type=script&lang=ts"
import style0 from "./merchantProduct.vue?vue&type=style&index=0&id=79f01f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f01f8e",
  null
  
)

export default component.exports